var _mask, _rect, _path, _rect2, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4120_3721",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17.8037,
    width: 6.70996,
    height: 13.1963,
    rx: 1.25253
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.8037,
    width: 6.70996,
    height: 13.1963,
    rx: 1.25253,
    stroke: "#A6A6A6",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_4120_3721)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75488 19.8774H15.1936C15.7459 19.8774 16.1936 20.3251 16.1936 20.8774V22.2165C16.1936 22.7688 16.6413 23.2165 17.1936 23.2165H19.4257C19.6773 23.2165 19.9196 23.1217 20.1043 22.951L24.6738 18.7294C25.5814 17.8908 26.981 17.8902 27.8894 18.7278C28.8875 19.6482 28.9103 21.2172 27.9393 22.1661L21.7418 28.2226C21.3681 28.5878 20.8664 28.7923 20.344 28.7923H6.75488",
    stroke: "#A6A6A6",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.67065,
    y: 0.75,
    width: 20.4192,
    height: 11.6068,
    rx: 1.84452,
    stroke: "#A6A6A6",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6566,
    cy: 6.39706,
    r: 1.88925,
    stroke: "#A6A6A6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15723 3.13086H11.707",
    stroke: "#A6A6A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6509 9.70703H22.2007",
    stroke: "#A6A6A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.01e6556ab079aba126921855ab85aea8.svg";
export { ForwardRef as ReactComponent };